<template>
  <section>
    <div class="container page">
      <div class="space"></div>
      <div class="row">
        <div class="section-title center">
          <h2 class="text-center" style="text-transform:none"><strong>Contact us</strong></h2>
          <div class="line"></div>
        </div>
      </div>
      <div id="contact" class="text-center col-md-12">
        <div class="space"></div>
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="col-md-8">
                <h3>Form</h3>
                <ValidationObserver v-slot="{ handleSubmit }">
                  <form id="ci-contact-form" @submit.prevent="handleSubmit(onSubmit)">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <ValidationProvider name="First Name" rules="required|alpha" v-slot="{ errors }">
                      <label for="exampleInputEmail1">First Name</label>
                      <input
                        type="text"
                        class="form-control"
                        id="first"
                        name="Fisrt Name"
                        v-model="first_name"
                        placeholder="Enter First Name"
                      />
                      <span>{{ errors[0] }}</span>
  </ValidationProvider>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <ValidationProvider name="Last Name" rules="required|alpha" v-slot="{ errors }">
                      <label for="exampleInputEmail1">Last Name</label>
                      <input
                        type="text"
                        class="form-control"
                        id="last"
                        name="Last name"
                        v-model="last_name"
                        placeholder="Enter Last Name"
                      />
                      <span>{{ errors[0] }}</span>
  </ValidationProvider>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <ValidationProvider name="E-mail" rules="required|email" v-slot="{ errors }">
                      <label for="exampleInputEmail1">Email</label>
                      <input
                        type="email"
                        class="form-control"
                        id="exampleInputEmail1"
                        name="email"
                        v-model="email"
                        placeholder="Enter Email"
                      />
                      <span>{{ errors[0] }}</span>
  </ValidationProvider>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <ValidationProvider name="Pnone Number" rules="required|digits:10" v-slot="{ errors }">
                      <label for="exampleInputEmail1">Phone</label>
                      <input
                        type="tel"
                        class="form-control"
                        id="exampleInputEmail1"
                        name="phone"
                        v-model="phone"
                        placeholder="Enter phone number for call back "
                      />
                      <span>{{ errors[0] }}</span>
  </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <ValidationProvider name="Message" rules="required" v-slot="{ errors }">
                  <label for="exampleInputEmail1">How can we help you?</label>
                  <textarea
                    class="form-control"
                    rows="3"
                    name="message"
                    v-model="message"
                    placeholder="Enter your message"
                  ></textarea>
                  <span>{{ errors[0] }}</span>
  </ValidationProvider>
                </div>
                <div class="row">
                <button type="submit" class="btn tf-btn btn-default"> Submit </button>
                </div>
                <br>
                <div  v-if="processing" class="alert alert-info col-md-12">
                  <span>Submitting form...</span>
                </div>
                <div  v-if="success" class="alert alert-success">
                  <strong>Thank You!</strong> We will get back to you soon.
                </div>
              </form>
                </ValidationObserver>
              </div>
              <div class="col-md-4">
                <div class="section-title">
                  <h3>Info</h3>
                  <div class="clearfix"></div>
                </div>
                <div class="contact-details">
                  <ul>
                    <li>
                      <i class="fa fa-map-marker"> </i><span>1 Dey Farm Drive, Princeton Jct, NJ 08550, USA</span></a>
                    </li>
                    <li>
                      <i class="fa fa-phone"> </i><span>+1 732-494-4810 </span>
                    </li>
                    <li>
                      <i class="fa fa-fax"> </i><span>+1 732-494-4876 </span>
                    </li>
                    <li>
                      <i class="fa fa-envelope"> </i><a href="mailto:info@compu-info.com"><span>info@compu-info.com </span></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
  import axios from 'axios';
  export default {
    
    data() {
      return {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        message: '',
        success: false,
        processing: false,
      };
    },
    methods: {
      onSubmit () {
            this.processing = true;
            axios.post(
              'https://formspree.io/f/xjvpwjwa',
              {
                _subject: 'compu-info contact form submision',
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email,
                phone: this.phone,
                message:this.message,
              },
            )
        .then((response) => {
              window.location.reload();
              this.processing=false
              this.success=true
              console.log(response);
        })
       .catch((error) => {
                console.log(error);            
                     // error.response.status Check status code
                 });
        

      }
    }
  };

</script>
